import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkSpacing } from 'uitk-react-spacing';

export interface BodyRegionProps {
  templateContent: React.ReactElement<unknown>;
  pageHeader?: string;
}
export class BodyRegion extends React.Component<BodyRegionProps> {
  public render() {
    const { pageHeader, templateContent } = this.props;

    const header = pageHeader && (
      <header>
        <h1 className="is-visually-hidden">{pageHeader}</h1>
      </header>
    );

    const mainRegion = (
      <div>
        {header}
        <div className="main-region">
          <ErrorBoundary label="hotel.masterPage.template">{templateContent}</ErrorBoundary>
        </div>
      </div>
    );

    return <UitkSpacing margin={{ medium: { inline: 'six' } }}>{mainRegion}</UitkSpacing>;
  }
}
